import FlexBox from '@/atomic-components/FlexBox';
import { IOffers } from '@/components/ProductDisplayPage/model';
import { getColor } from '@/utils/theme/colors';
import { getStyle } from '@/utils/theme/fonts';
import { Box, Drawer } from '@mui/material';
import DiscountBadgeIcon from '../../../../../assets/pdp/discountBadgeIcon.svg';
import CopyIcon from '../../../../../assets/pdp/copyIcon.svg';
import { useEffect, useState } from 'react';
import { LencoTypography } from '@/atomic-components/LencoTypography';
import { useNotification } from '@/hooks/useNotification';
import { NotificationSeverity } from '@/components/NotifyToast';
import OfferTile from '@/components/Cart/CartOffers/OfferTile';

import { CART_TYPE } from '@/services/cart/models/cart';
import { ApiState } from '@/models/generics';
type OfferDrawerComponentProps = {
	offer?: IOffers;
	open: boolean;
	nonApplicableOffers?: any;
	onClose: () => void;
	addEvents?: any;
	codeCopied?: boolean;
	setCodeCopied?: any;
	OfferAppliedCart?: any;
	isTermConditionsVisible?: boolean;
	cartType?: CART_TYPE;
	removeCouponApiState?: ApiState;
	offerAppliedCart?: any;
	applyOfferToCart?: any;
	removingCouponCode?: boolean;
	onRemove?: (e: any) => void;
	hasNonApplicableOffers?: boolean;
};

const OfferDrawerComponent = (props: OfferDrawerComponentProps) => {
	const { offer } = props;

	const ActionOnDrawerClose = () => {
		props.onClose();
	};
	const { actions } = useNotification();
	const [isApplicable, setIsApplicable] = useState(false);

	useEffect(() => {
		if (props?.hasNonApplicableOffers) {
			const isNotApplicableOffer = props?.nonApplicableOffers.find(
				(offers: any) => offers.code === offer?.code
			);

			if (isNotApplicableOffer !== undefined) {
				setIsApplicable(true);
			} else {
				setIsApplicable(false);
			}
		}
	}, [offer, props?.hasNonApplicableOffers]);
	const ActionOnCopyCode = (offerCode: string) => {
		navigator.clipboard.writeText(offerCode);
		props.setCodeCopied(offerCode);
		props.addEvents('PDP Offers and Discounts Copied', offer?.expiryText);

		actions.notifyUser({
			message: 'Coupon code copied!',
			severity: NotificationSeverity.SUCCESS,
		});
	};

	return (
		<Drawer open={props.open} anchor='right' onClose={ActionOnDrawerClose}>
			<Box
				sx={{
					padding: ' 80px 60px',
					width: '460px',
				}}
			>
				{props?.isTermConditionsVisible ? (
					<Box sx={{ paddingBottom: '24px' }}>
						<OfferTile
							rentOffer={offer}
							isDrawer={true}
							isTermConditionsVisible={props?.isTermConditionsVisible}
							isnonApplicableOffers={isApplicable}
							rentCart={props?.OfferAppliedCart}
							applyOfferToCart={props?.applyOfferToCart}
							cartType={props.cartType}
							removingCouponCode={
								props?.removeCouponApiState === ApiState.LOADING
							}
							onRemove={props?.onRemove}
							isApplied={
								props?.OfferAppliedCart?.appliedCoupon?.appliedCouponId ===
								offer?.id
							}
						/>
					</Box>
				) : (
					<Box
						sx={{
							width: '360px',
							background: `linear-gradient(-270deg, #FFF5B7 0%, #FFFBDB 100%)`,
							marginBottom: '40px',
							alignItem: 'flex-start',
							justifyContent: 'flex-start',
						}}
					>
						<Box
							sx={{
								width: '100%',
								right: '0',
								bottom: '0',
								backgroundSize: 'contain',
								backgroundPositionX: 'right',
								backgroundRepeat: 'no-repeat',
								backgroundImage: `url(https://assets.furlenco.com/s3-furlenco-images/grogu/OfferIcon.svg)`,
							}}
						>
							<FlexBox sx={{ padding: '22px 16px 26px 16px' }}>
								<DiscountBadgeIcon />
								<FlexBox direction='column' sx={{ paddingLeft: '8px' }}>
									<LencoTypography
										sx={{
											...getStyle('H10_Medium'),
										}}
									>
										{offer?.header}
									</LencoTypography>
									<LencoTypography
										sx={{
											...getStyle('P_Medium'),
											color: '#937517',
											paddingBottom: '16px',
										}}
									>
										Coupon code : {offer?.code}
									</LencoTypography>
									{!props.codeCopied ? (
										<FlexBox
											sx={{
												border: `1px solid ${getColor('Gray -4')}`,
												height: '40px',
												width: '120px',
												justifyContent: 'center',
												alignItems: 'center',
												cursor: 'pointer',
												backgroundColor: '#FFFFFF',
												borderRadius: '8px',
											}}
											onClick={() => {
												offer?.code && ActionOnCopyCode(offer.code as string);
											}}
										>
											<CopyIcon />
											<LencoTypography
												sx={{
													...getStyle('Small_Medium'),
													color: getColor('Minty 0'),
													paddingLeft: '8px',
												}}
											>
												Copy Code
											</LencoTypography>
										</FlexBox>
									) : (
										<FlexBox
											sx={{
												height: '40px',
												width: '120px',
												justifyContent: 'center',
												alignItems: 'center',
												cursor: 'pointer',
												backgroundColor: getColor('Success +1'),
												borderRadius: '8px',
											}}
										>
											<LencoTypography
												sx={{
													...getStyle('Small_Medium'),
													color: '#FFFFFF',
												}}
											>
												Code copied !
											</LencoTypography>
										</FlexBox>
									)}
									{offer?.expiryText && offer?.expiryText?.length > 0 && (
										<LencoTypography
											sx={{
												...getStyle('Tiny_Medium'),
												color: getColor('Danger -1'),
												paddingBottom: '16px',
											}}
										>
											{offer?.expiryText}
										</LencoTypography>
									)}
								</FlexBox>
							</FlexBox>
						</Box>
					</Box>
				)}
				<LencoTypography
					sx={{ ...getStyle('P_Regular'), color: getColor('Gray -2') }}
				>
					{offer?.longDescription}
				</LencoTypography>
				<LencoTypography
					sx={{
						...getStyle('Small_Regular'),
						color: getColor('Gray -2'),
						paddingTop: '8px',
					}}
				>
					{offer?.whereToApply}
				</LencoTypography>
				<Box
					sx={{
						border: `1px solid ${getColor('Gray -4')}`,
						width: '100%',
						marginTop: '24px',
					}}
				></Box>
				<LencoTypography
					sx={{
						...getStyle('H14_Medium'),
						paddingTop: '24px',
						color: getColor('Gray -1'),
					}}
				>
					Terms & Conditions
				</LencoTypography>
				{offer?.termsAndConditions.map((tnc, index) => {
					return (
						<LencoTypography
							key={index}
							sx={{
								...getStyle('Small_Regular'),
								color: getColor('Gray -2'),
							}}
						>
							- {tnc}
						</LencoTypography>
					);
				})}
			</Box>
		</Drawer>
	);
};

export default OfferDrawerComponent;
